import { FC, ReactNode } from 'react';

interface IOrderMethodItem {
  children: ReactNode;
  icon: ReactNode;
  title: string | ReactNode;
}

const OrderMethodItem: FC<IOrderMethodItem> = ({ children, icon, title }) => {
  return (
    <div className='p-4 mb-6 border rounded-lg bg-t-bg-color border-t-border-color-base'>
      <div className='flex flex-col items-stretch gap-6 md:items-center md:flex-row border-t-border-color-base'>
        <div className='flex flex-col items-center justify-center w-full pb-4 border-b md:pb-0 md:w-1/5 md:border-l md:border-b-0 '>
          <div className=''>{icon}</div>
          <div className='text-sm'>{title}</div>
        </div>
        <div className='w-full md:w-4/5'>{children}</div>
      </div>
    </div>
  );
};

export default OrderMethodItem;
